// 038 (Trabajo Social) — situación socioeconómica familiar: el total de egresos y la
// disponibilidad económica se CALCULAN, no se tipean a mano (mismo criterio que
// cualquier total derivado — ver skill de xlsx, "usar fórmulas, nunca resultados
// hardcodeados", trasladado acá a un cálculo de UI). Puro, testeable sin DOM.
export interface EgresosFamiliares {
  alimentacion: number;
  vivienda: number;
  serviciosBasicos: number;
  educacion: number;
  salud: number;
  movilizacion: number;
  otros: number;
}

export interface SituacionEconomica {
  totalEgresos: number;
  disponibilidad: number;
}

export function calcularSituacionEconomica(ingresos: number, egresos: EgresosFamiliares): SituacionEconomica {
  const totalEgresos = Object.values(egresos).reduce((suma, valor) => suma + (Number.isFinite(valor) ? valor : 0), 0);
  return { totalEgresos, disponibilidad: ingresos - totalEgresos };
}
